import React from 'react';

/** String Helper */

/**
 * Replace a undefined or NULL string with something else
 *
 * @param  {String} [string=''] 	The string to check if undefined or NULL
 * @param  {String} [replacer=''] 	The string to replace it with
 * @return {String} string
 */
export const replaceEmpty = (string = '', replacer = '') => {
  return typeof string === 'undefined' || string === null ? replacer : string;
};

export const cleanNumber = (n) => {
  let number = n;

  if (typeof number === 'string') {
    number = number.replace(/[^.0-9]/g, '');
  }

  return number ? parseFloat(number) : 0;
};

export const renderAsHTML = (string) => React.createElement('span', { dangerouslySetInnerHTML: { __html: string } });

export const decodeEntities = (string) => {
  const element = document.createElement('div');
  let newString = string;
  if (newString && typeof newString === 'string') {
    // strip script/html tags
    newString = newString.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
    newString = newString.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
    element.innerHTML = newString;
    newString = element.textContent;
    element.textContent = '';
  }
  return newString;
};

export const formattedNumber = (number, seperator, decimals, prefix = '') => {
  const num = cleanNumber(number).toFixed(decimals);
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, seperator);
  return renderAsHTML(`${prefix}${parts.join('.')}`);
};

export const dollarFormat = (number, seperator = '&nbsp;', decimals = 0, prefix = '$') => formattedNumber(number, seperator, decimals, prefix);

export const toKebabCase = (string) => {
  let newString = string.replace(/^\s+|\s+$/g, '');
  newString = newString.toLowerCase();
  // remove accents...
  const accents = 'āàáäâēèéëêīìíïîōòóöôūùúüûñç·/_,:;';
  const plain = 'aaaaaeeeeeiiiiiooooouuuuunc------';
  for (let i = 0, l = accents.length; i < l; i += 1) {
    newString = newString.replace(new RegExp(accents.charAt(i), 'g'), plain.charAt(i));
  }
  newString = newString
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return newString;
};

export const toCamelCase = (string) => {
  return string
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
};
